import React from 'react';
import { useSubscription } from '@/hooks/useSubscription';
import { PlanLimitsContext } from '@/contexts/PlanLimitsContextInternal';
import { useFeatureFlag, FeatureFlag } from '@lingugeek/ui';

export const PlanLimitsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isEnabled: subscriptionsEnabled } = useFeatureFlag(
    FeatureFlag.ENABLE_SUBSCRIPTIONS
  );
  const { subscription, isLoading } = useSubscription();

  // When subscriptions are disabled, provide free plan defaults
  const effectivePlan = subscriptionsEnabled ? subscription?.plan : 'free';
  const effectiveStatus = subscriptionsEnabled
    ? subscription?.status
    : 'active';
  const effectiveLimits = subscriptionsEnabled
    ? (subscription as { limits?: Record<string, unknown> })?.limits
    : {
        daily_words: 5,
        topics: 3,
        delivery_times: 1,
      };

  return (
    <PlanLimitsContext.Provider
      value={{
        plan: effectivePlan,
        status: effectiveStatus,
        expiresAt: undefined, // currentPeriodEnd not available in current API
        limits: effectiveLimits,
        isLoading: subscriptionsEnabled ? isLoading : false,
      }}
    >
      {children}
    </PlanLimitsContext.Provider>
  );
};
